export default {
  created: function () {
    if (this.$options.hasTab) {
      // 如果当前的路由路径没有在当前打开的menuTree下
      if (this.$route && this.$route.path.indexOf(this.$store.getters.menuActive) === -1) {
        // 根据路由获取当前的menuActive
        const menuActive = this.$route.path.split('/')[1]
        // 判断当前menuActive对应的路由是否已注册到menuTree里了
        if (this.$store.getters.menuTree.findIndex(menu => menu.name === menuActive) === -1) {
          // 如果没有在menuTree中，则将对应路由加入到menuTree里
          const routes = this.$router.options.routes[0].children // 路由配置中的第一项是页面路由存贮的位置，第一项的children就是真实路由所在的地方.
          const routeInfo = routes.find(route => route.name === menuActive)
          if (routeInfo) {
            this.$store.dispatch('clearTabList')
            this.$store.dispatch('openMenu', routeInfo)
          }
        } else {
          // 如果已经在menuTree中，则直接打开对应menuTree
          this.$store.dispatch('clearTabList')
          this.$store.dispatch('setMenuActive', menuActive)
        }
      }
      // 打开tab
      if (this.$route.name !== 'ProjiectInforList') {
        this.$store.dispatch('openTab', this.$route)
      }
    }
  },
  activated: function () {
    // if (this.$options.hasTab && this.$options.parent.$route.meta && this.$options.parent.$route.meta.keep) {
    if (this.$options.hasTab) {
      if (this.$route && this.$route.path.indexOf(this.$store.getters.menuActive) === -1) {
        const menuActive = this.$route.path.split('/')[1]
        if (menuActive) {
          this.$store.dispatch('setMenuActiveOnly', menuActive)
        }
      }
      if (this.$route.name !== 'ProjiectInforList') {
        this.$store.dispatch('openTab', this.$route)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/area-base/mixin/index.js